import React from 'react';
import { connect } from 'react-redux';
import { userActions } from 'redux/actions';
import { Home } from './components';
import { MainLayout } from '@mous221/hk-components';

const HomePage = (props) => (
  <MainLayout footer="main" children={<Home {...props} />} {...props} />
);

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(userActions.logout()),
});

export default connect(() => ({}), mapDispatchToProps)(HomePage);
